module.exports = __webpack_public_path__ + "img/logo-apolar-lancamentos-black.c250ca3d.webp";